import React from "react";
import styles from "./DialerHeader.module.css";

const STATUS_TEXT = {
  idle: "Connecting…",
  initializing: "Connecting…",
  reconnecting: "Reconnecting…",
  ready: "Ready",
  error: "Offline",
  // Device theek hai — bas dial karne layak number nahi mila.
  notready: "Not set up",
};

const DialerHeader = ({ deviceStatus, onBack, onRetry }) => {
  const status = STATUS_TEXT[deviceStatus] || "Connecting…";
  const isReady = deviceStatus === "ready";
  const isError = deviceStatus === "error";
  const isNotReady = deviceStatus === "notready";

  return (
    <div className={styles.header}>
      <button type="button" className={styles.backBtn} onClick={onBack} aria-label="Back">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M15 19l-7-7 7-7"
            stroke="#24252c"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <img className={styles.logo} src="/svg/Rexpt-Logo.svg" alt="Rexpt" />

      {isError ? (
        <button type="button" className={styles.retryBtn} onClick={onRetry}>
          Retry
        </button>
      ) : (
        <span className={styles.status}>
          <span
            className={`${styles.statusDot} ${isReady ? styles.dotReady : ""} ${
              isNotReady ? styles.dotIdle : ""
            }`}
          />
          {status}
        </span>
      )}
    </div>
  );
};

export default DialerHeader;
